import { connect } from 'react-redux';

import * as CommonAction from '../../../actions/Common.actions';
import { SIGN_IN_FORM } from '../../../constants/FormNames';
import LogInContainer from './Login.component';

const mapStateToProps = ({ forms }) => ({
	formData: forms?.[SIGN_IN_FORM]?.values || {},
});

export default connect(mapStateToProps, { editModal: CommonAction.editModal })(
	LogInContainer
);
